export const services = [
    {
        title: "Marketing",
        icon: 0,
        description: "Fortalecemos marcas, aumentamos a visibilidade e ajudamos empresas a conquistar novos clientes com estratégias inteligentes.",
        features: [
            "Estratégia e Planeamento de Marketing",
            "Branding e Posicionamento de Marca",
            "Rebranding ",
            "Gestão de crise de imagem da marca",
            "Gestão de Redes Sociais",
            "Tráfego Pago (Facebook Ads, Google Ads, LinkedIn Ads)",
            "SEO e Marketing de Conteúdo",
            "Email Marketing e Automação",
            "Produção de Conteúdos institucionais e corporativos (artigos, vídeos, eBooks, newsletters)",
        ]
    },
    {
        title: "Comunicação e Eventos",
        icon: 1,
        description: "Planeamos e executamos eventos corporativos de forma memorável, alinhando imagem e estratégia.",
        features: [
            "Cobertura fotográfica e audiovisual de eventos",
            "Produção e organização de eventos",
            "Criação de conteúdos visuais e institucionais",
            "Publicidade",
            "Relações Públicas e Comunicação Corporativa",
            "Eventos, Ativações de Marca e Endomarketing",
        ]
    },
    {
        title: "Consultoria &  Auditoria",
        icon: 2,
        description: "Apoiamos empresas na tomada de decisões estratégicas, na otimização de processos e na gestão de mudanças.",
        features: [
            "Planeamento Estratégico e Reestruturação Empresarial",
            "Gestão da Mudança e Gestão de Crise",
            "Diagnóstico Organizacional e Mapeamento de Processos",
            "Gestão de Projetos (Publico e Privado) e Implementação de KPIs",
            "Consultoria em Marketing e Comunicação",
            "Estudos de Mercado e Concorrência",
            "Auditoria Interna, Financeira e de Conformidade",
            "Auditoria de Marketing e Performance Empresarial",
            "Relatórios de Business Intelligence e Pesquisas de Satisfação",

        ]
    },
    {
        title: "Finanças & Investimentos",
        icon: 3,
        description: "Oferecemos soluções financeiras para garantir sustentabilidade, crescimento e atração de investimentos.",
        features: [
            "Diagnóstico Financeiro e Gestão de Fluxo de Caixa",
            "Planeamento Financeiro Estratégico e Orçamentação",
            "Controlo de Custos e Rentabilidade",
            "Modelagem Financeira e Estruturação de Negócios",
            "Gestão de Riscos Financeiros",
            "Captação de Investimentos (bancários, privados e venture capital)",
            "Preparação de Pitch Deck para Investidores",
            "Valuation (Avaliação de Empresas e Projetos)",
            "Auditoria Financeira e Estudos de Viabilidade",
            "Formação em Finanças e Educação Financeira para Gestores",
        ]
    },
    {
        title: "Incubação & Aceleração",
        icon: 4,
        description: "Impulsionamos startups e negócios em crescimento com programas de incubação, mentoria e acesso a capital.",
        features: [
            "Estruturação de Modelos de Negócio (Canvas, Lean Startup)",
            "Mentoria Estratégica em Gestão, Marketing e Finanças",
            "Programas de Incubação e Aceleração (bootcamps, sprints, formações)",
            "Apoio na Constituição Legal e Administrativa da Empresa",
            "Estratégias de Captação de Clientes e Expansão",
            "Preparação para Rodadas de Investimento (pré-seed, seed, série A, etc.)",
            "Internacionalização e Expansão de Mercado",
            "Networking com Investidores, Parceiros e Ecossistemas de Inovação",
            "Consultoria em Transformação Digital e Inovação Aberta",
            "Conexão entre Startups e Grandes Empresas (Corporate Innovation)",

        ]
    },
    {
        title: "Treinamentos Empresariais & Profissionais",
        icon: 5,
        description: "Acreditamos que o crescimento das organizações depende do desenvolvimento das pessoas. Por isso, oferecemos treinamentos e capacitações para fortalecer competências, alinhar equipas e preparar líderes e empreendedores para os desafios do mercado.",
        features: [
            "Treinamentos Corporativos Personalizados",
            "Workshops Práticos e Interativos",
            "Masterclass",
            "Gestão e Estratégia",
            "Marketing, Vendas e Inovação",
            "Soft Skills e Desenvolvimento Pessoal",
            "Capacitação para Empreendedores",
            "Mentoria e Coaching Empresarial",
        ]
    },
]

export const CompanyValues = [
    {
        title: "Excelência",
        description: "Entregar sempre soluções de alto nível, superando expectativas."
    },
    {
        title: "Inovação",
        description: "Explorar novas ideias, tecnologias e abordagens criativas para gerar impacto."
    },
    {
        title: "Compromisso",
        description: "Trabalhar com dedicação e responsabilidade em cada projeto."
    },
    {
        title: "Colaboração",
        description: "Construir relações sólidas e parcerias estratégicas baseadas em confiança."
    },
    {
        title: "Sustentabilidade",
        description: "Promover crescimento responsável e duradouro para negócios e comunidade."
    },
    {
        title: "Foco em Resultados",
        description: "Medir o sucesso pelo impacto real que geramos para os nossos clientes."
    },
]

export const OrganizationalIdentity = [
    {
        title: "Missão",
        icon: 0,
        description: "Impulsionar o crescimento sustentável de empresas e empreendedores, oferecendo soluções estratégicas em consultoria, marketing e inovação que combinam visão de futuro, criatividade e foco em resultados. Trabalhamos para transformar ideias em negócios sólidos, fortalecer marcas e criar valor duradouro para os nossos clientes, parceiros e comunidade.",
    },
    {
        title: "Visão",
        icon: 1,
        description: "Ser reconhecida como a parceira estratégica de referência em consultoria, marketing e inovação em Cabo Verde e nos mercados internacionais, destacando-nos pela capacidade de gerar resultados, criar valor e antecipar tendências que impulsionam o sucesso dos nossos clientes.",
    }
]

export const FacebookLink = "https://www.facebook.com/share/1HFCYiL5UD/";
export const InstagramLink = "https://www.instagram.com/upconsultinvest.cv?igsh=MXFhdDZzbDk1NXB1bQ==";
export const LinkedInLink = "https://www.linkedin.com/company/up-consultinvest/";

export const CompanyInfo = {
    facebookLink: FacebookLink,
    instagramLink: InstagramLink,
    linkedInLink: LinkedInLink,
    contact: "+238 980 75 67",
    email: "geral@upconsultinvest.com",
    location: ""
}